import MuiMenu, { MenuProps as MuiMenuProps } from "@mui/material/Menu";
import React, { FunctionComponent } from "react";

export interface MenuProps extends MuiMenuProps {
	/** alignment of popup menu relative to anchor (default is "center") */
	align?:
	| "center"
	| "left"
	| "right";
}

const Menu: FunctionComponent<MenuProps> = (props) => {
	const { align, anchorOrigin, onClose, transformOrigin, ...otherProps } = props;
	const halign = align || "center";

	return (
		<MuiMenu
			anchorOrigin={anchorOrigin || {
				horizontal: halign,
				vertical: "bottom",
			}}
			onClick={(event) => onClose(event, "backdropClick")}
			onClose={onClose}
			transformOrigin={transformOrigin || {
				horizontal: halign,
				vertical: "top",
			}}
			{...otherProps}
		/>
	);
};

export default Menu;